import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { api_crud_base, api_crud_route, api_list_route, data_inputs, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';

import {
	reqGET,
	reqPOST,
	reqPUT,
	translate,
} from '../../../Utils';

import UseSidebar from '../../../UseSidebar';

import { language } from './Language';

import Swal from 'sweetalert2'

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const entity_category_filter = useRef(null);
	const entity_type_filter = useRef(null);
	const entity_nature_filter = useRef(null);
	const entity_quality_filter = useRef(null);
	const entity_legal_form_filter = useRef(null);

	const entidadeOptions = [
		{ id: "1", label: "Interna" },
		{ id: "2", label: "Externa" },
	];

	const [entity_category, set_entity_category] = useState([])
	const [entity_type, set_entity_type] = useState([])
	const [entity_nature, set_entity_nature] = useState([])
	const [entity_quality, set_entity_quality] = useState([])
	const [entity_legal_form, set_entity_legal_form] = useState([])

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);

	const [is_edit, set_is_edit] = useState(false)
	const [, setRefresh] = useState(0)

	const fetch_entity_attributes = async (type) => {
		
		let res = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if(res.data !== undefined) {
			for await (let el of res.data) {
				let aux = {
					id: el.id,
					name: translate(el.info.name, 'pt'),
					type: el.info.type,
					parent: el.info.parent
				}

				result.push(aux)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {

		(async () => {
		})()

	}, [])

	useEffect(() => {

		(async () => {

			let res_1 = await fetch_entity_attributes('entity_category')
			let res_2 = await fetch_entity_attributes('entity_type')
			let res_3 = await fetch_entity_attributes('entity_nature')
			let res_4 = await fetch_entity_attributes('entity_quality')
			let res_5 = await fetch_entity_attributes('entity_legal_form')

			set_entity_category(order_array(res_1))
			set_entity_type(order_array(res_2))
			set_entity_nature(order_array(res_3))
			set_entity_quality(order_array(res_4))
			set_entity_legal_form(order_array(res_5))

			set_lang(localStorage.getItem('lang'))

			const fetch_id_info = async (id_serch) => {
				let res = await reqGET(`${api_list_route(getTokenInfo().companycode)}/${id_serch}`)
				if(res.data.length > 0) {

					if(res.data[0].settings.entity_category !== undefined && res.data[0].settings.entity_category !== '') {
						set_dados(entity_type_filter.current = res_2.filter(el => parseInt(el.parent) === parseInt(res.data[0].settings.entity_category)))
					}
					if(res.data[0].settings.entity_type !== undefined && res.data[0].settings.entity_type !== '') {
						set_dados(entity_nature_filter.current = res_3.filter(el => parseInt(el.parent) === parseInt(res.data[0].settings.entity_type)))
					}

					set_dados(dados.current = res.data[0])

				}
			}

			const clean_data = () => {
				// DEEP COPY OF data_interface 
				set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
				set_dados(dados.current.settings.companycode = getTokenInfo().companycode)
			}

			clean_data();

			try {
				let test = props.location.state.operation;

				if (test === 'edit') {
					await fetch_id_info(props.location.state.item['id'])
					set_is_edit(true)
					setLoading(false)
				}

			} catch {
				clean_data()

				setLoading(false);

				await UseSidebar().getSidebar(null).then(v => { set_dados(dados.current.settings.menu = v) })
			}
			return () => {
				clean_data()
			}

		})()

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		let guardarLink = endpoints.list

		if (is_edit === true) {

			try {

				dados.current.settings.menu = []

				await reqPUT(api_crud_route, dados.current)
					.then(() => Swal.fire('', 'Registo Atualizado com Sucesso!', 'info')) //window.location.reload())//alert('Registo Atualizado com Sucesso!'))
					.catch(() => Swal.fire('', 'Problema ao atualizar Registo!', 'info'))
		
			} catch {
				props.history.push(guardarLink)
			}
		} 
		else {
			//console.log('---------------> NO POST')
			await reqPOST(api_crud_route, dados.current)
				.then(() => Swal.fire('', 'Registo Inserido com Sucesso!', 'info')) 
				.catch(() => Swal.fire('', 'Problema ao atualizar Registo!', 'info'))
			
			props.history.push(guardarLink)
		}

	}

	const handle_change_name = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/
		/* 
			console.log('NAME:' + name)
			console.log('Value:' + value)
		*/
		set_dados(dados.current.settings[name] = value)
		set_dados(dados.current[name] = value)

		/*console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))*/

	}

	const handleSingleCheck = e => {
		const { name } = e.target;

		let ver_submenu = (node) => {
			if (node.submenu.length !== 0) {
				node.submenu.forEach(subitem => {

					if (subitem.id === name) {
						subitem.allow = !subitem.allow
					} 
					else if (name === (subitem.id + '_create')) {
						subitem.create = !subitem.create
					} 
					else if (name === (subitem.id + '_edit')) {
						subitem.edit = !subitem.edit
					}
					else if (name === (subitem.id + '_remove')) {
						subitem.remove = !subitem.remove
					} 
					else if (name === (subitem.id + '_dash')) {
						subitem.dash = !subitem.dash
					} 
					else if (name === (subitem.id + '_admin')) {
						console.log('Admin subitem', subitem)
						subitem.admin = !subitem.admin
					} 
					else {
						ver_submenu(subitem)
					}

				})
			}
		}

		dados.current.settings.menu.forEach(node => {

			if (node.id === name) {
				node.allow = !node.allow
			} 
			else if (name === (node.id + '_create')) {
				node.create = !node.create
			} 
			else if (name === (node.id + '_edit')) {
				node.edit = !node.edit
			} 
			else if (name === (node.id + '_remove')) {
				node.remove = !node.remove
			} 
			else if (name === (node.id + '_dash')) {
				node.dash = !node.dash
			} 		
			else if (name === (node.id + '_admin')) {
				node.admin = !node.admin
			} 	
			else {
				ver_submenu(node)
			}

		}) 

		// set_dados(dados.current.settings.menu = dados.current.settings.menu)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
		return
	}

	const handle_change_settings = (e) => {
		const { name, value  } = e.target;

		if(name === 'entity_category') {
			set_dados(entity_type_filter.current = entity_type.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_nature_filter.current = [])
			set_dados(entity_quality_filter.current = [])
			set_dados(entity_legal_form_filter.current = [])
		}
		if(name === 'entity_type') {
			set_dados(entity_nature_filter.current = entity_nature.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_quality_filter.current = [])
			set_dados(entity_legal_form_filter.current = [])
		}
		if(name === 'entity_nature') {
			console.log('value', value)
			console.log('entity_quality', entity_quality)
			set_dados(entity_quality_filter.current = entity_quality.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_legal_form_filter.current = entity_legal_form.filter(el => parseInt(el.parent) === parseInt(value)))
		}

		set_dados(dados.current.settings[name] = value)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
		// console.log('Dados Current', dados.current.settings)
	}

	const handle_entity_input = (e) => {
		const { value, checked } = e.target;

		if (!dados.current.settings.inputs) {
			dados.current.settings.inputs = [];
		}

		if (checked) {
			if (!dados.current.settings.inputs.some(item => item === value)) {
				set_dados(dados.current.settings.inputs.push(value))
			}
		}
		else {
			set_dados(dados.current.settings.inputs = dados.current.settings.inputs.filter(item => parseInt(item) !== parseInt(value)))
		}

		console.log('dados.current.settings.inputs', dados.current.settings.inputs)
	};


	return isloading ?
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">LOADING</h2>
				<p>LOADING</p>
				<div className="overlay">
					<div className="overlay__inner">
						<div className="overlay__content"><span className="spinner"></span></div>
					</div>
				</div>
			</div>
		</main>
	:
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">Tipo de entidade</h2>
				<p>Home / Tipo de entidade / Inserir tipo de entidade</p>
			</div>

			<div className={`dash-cards-2 body`}>
				<div className="card">
					<div className="card-body">

						<form id="form" onSubmit={handleSubmit}>
							<h2 className="dash-title">Tipo de Entidade</h2>
							<div className="form-group">
								<span className="flex-2">
									<label>Nome do tipo de entidade</label>
									<input type="text" name="name" value={dados?.current?.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder="Introduza o nome" onChange={handle_change_name} required />
								</span>
							</div>

							<div className='row my-4 form-group'>
								<span className="col-6 col-md-4 mb-3">
									<label>Categoria</label>
									<select className="form-select rounded-0" aria-label="Escolher categoria" name='entity_category' value={dados?.current?.settings?.entity_category} onChange={(e) => handle_change_settings(e)}>
										<option value="">Escolher categoria</option>
										{
										entity_category !== undefined ?
											entity_category.map((el, k_el) => {
												return (
													<option key={k_el} value={el.id}>{el.name}</option>
												)
											})
										:
											null
										}
									</select>
								</span>

								{
								dados?.current?.settings?.entity_category !== undefined && entity_type_filter.current !== null && entity_type_filter.current.length > 0 ?
									<span className="col-6 col-md-4 mb-3">
										<label>Tipo de Entidade</label>
										<select className="form-select rounded-0" aria-label="Escolher tipo" name='entity_type' value={dados?.current?.settings?.entity_type} onChange={(e) => handle_change_settings(e)}>
											<option value="">Escolher tipo</option>
											{
											entity_type_filter.current.map((el, k_el) => {
												return (
													<option key={k_el} value={el.id}>{el.name}</option>
												)
											})
											}
										</select>
									</span>
								:
									null
								}

								{
								dados?.current?.settings?.entity_type !== undefined && entity_nature_filter.current !== null && entity_nature_filter.current.length > 0 ?
									<span className="col-6 col-md-4 mb-3">
										<label>Natureza jurídica</label>
										<select className="form-select rounded-0" aria-label="Escolher tipo" name='entity_nature' value={dados?.current?.settings?.entity_nature} onChange={(e) => handle_change_settings(e)}>
											<option value="">Escolher tipo</option>
											{
											entity_nature_filter.current.map((el, k_el) => {
												return (
													<option key={k_el} value={el.id}>{el.name}</option>
												)
											})
											}
										</select>
									</span>
								:
									null
								}

								{
								false && dados?.current?.settings?.entity_nature !== undefined && entity_legal_form_filter.current !== null && entity_legal_form_filter.current.length > 0 ?
									<span className="col-6 col-md-4 mb-3">
										<label>Forma jurídica</label>
										<select className="form-select rounded-0" aria-label="Escolher tipo" name='entity_legal_form' value={dados?.current?.settings?.entity_legal_form} onChange={(e) => handle_change_settings(e)}>
											<option value="">Escolher tipo</option>
											{
											entity_legal_form_filter.current.map((el, k_el) => {
												return (
													<option key={k_el} value={el.id}>{el.name}</option>
												)
											})
											}
										</select>
									</span>
								:
									null
								}

								{
								false && dados?.current?.settings?.entity_nature !== undefined && entity_quality_filter.current !== null && entity_quality_filter.current.length > 0 ?
									<span className="col-6 col-md-4 mb-3">
										<label>Qualidade Intervenção</label>
										<select className="form-select rounded-0" aria-label="Escolher tipo" name='entity_quality' value={dados?.current?.settings?.entity_quality} onChange={(e) => handle_change_settings(e)}>
											<option value="">Escolher tipo</option>
											{
											entity_quality_filter.current.map((el, k_el) => {
												return (
													<option key={k_el} value={el.id}>{el.name}</option>
												)
											})
											}
										</select>
									</span>
								:
									null
								}
							</div>

							<h2 className="dash-title">Campos de inserção</h2>
							<div className="col-md-12">
								<label className='fs-5 fw-bold mb-2'>Entidade Externa</label>
								<div className='row'>
									<div className='col-6'>
										<label className='fs-6 fw-bold mb-2'>Coletiva</label>
										<div className="row ms-1">
											{
												data_inputs?.externa?.coletiva !== undefined && data_inputs?.externa?.coletiva !== null ?
													data_inputs.externa.coletiva.map((option, key) => (
														<div key={key} className="col-md-4 form-check mb-2">
															<input
																name={option}
																type="checkbox"
																className="form-check-input"
																id={`relacao-${option}`}
																value={option}
																onChange={handle_entity_input}
																checked={dados.current.settings.inputs?.some(item => item === option) || false}
															/>
															<label className="form-check-label text-capitalize" htmlFor={`relacao-${option}`}>
																{option.split('_').join(' ')}
															</label>
														</div>
													))
													:
													null
											}
										</div>
									</div>
									<div className="col-6">
										<label className='fs-6 fw-bold mb-2'>Individual</label>
										<div className="row ms-1">
											{
												data_inputs?.externa?.individual !== undefined && data_inputs?.externa?.individual !== null ?
													data_inputs.externa.individual.map((option, key) => (
														<div key={key} className="col-md-4 form-check mb-3">
															<input
																name={option}
																type="checkbox"
																className="form-check-input"
																id={`relacao-${option}`}
																value={option}
																onChange={handle_entity_input}
																checked={dados.current.settings.inputs?.some(item => item === option) || false}
															/>
															<label className="form-check-label text-capitalize" htmlFor={`relacao-${option}`}>
																{option.split('_').join(' ')}
															</label>
														</div>
													))
													:
													null
											}
										</div>
									</div>
								</div>
							</div>


							<h2 className="dash-title d-none">Menus</h2>
							<div className="form-group d-none">
								{
								false ?
									<span className="flex-1">
										<label >Lista de Entradas Disponíveis</label>
										<br />
										{
										dados?.current?.settings?.menu !== undefined ?
											dados.current.settings.menu.map((item, key) => {

												if (item.title === '')
													return <div key={key}></div>
												else
													return (
														<div key={key} className='div-list ps-4'>
															<div className="d-flex py-4">
																<span className="flex-1 mb-0">
																	<div className='d-flex'>
																		<i className={"bi bi-" + (item.icon !== '' ? item.icon : 'dash-lg invisible') + " fs-5 me-4"}></i>
																		<label key={key} className="div-checkbox fs-5 mb-0">
																			<strong>{item.title}</strong>
																			<input
																				name={item.id}
																				className="checkbox-form"
																				type="checkbox"
																				value={item.title}
																				onChange={handleSingleCheck}
																				defaultChecked={item.allow}
																			/>
																			<span key={key} className="checkmark"></span>
																		</label>
																	</div>
																</span>
																<span className="flex-2 mb-0">
																	{
																	item.path.trim() !== '' && item.path.trim() !== '/' ?
																		<ul className='list-unstyled mb-0'>
																			{
																			item.create !== undefined ?
																				<li>
																					<label className="div-checkbox fs-5 mb-3">
																						Criar
																						<input
																							name={item.id + '_create'}
																							className="checkbox-form"
																							type="checkbox"
																							onChange={handleSingleCheck}
																							defaultChecked={item.create}
																						/>
																						<span className="checkmark"></span>
																					</label>
																				</li>
																			:
																				null
																			}
																			{
																			item.edit !== undefined ?
																				<li>
																					<label className="div-checkbox fs-5 mb-3">
																						Editar
																						<input
																							name={item.id + '_edit'}
																							className="checkbox-form"
																							type="checkbox"
																							onChange={handleSingleCheck}
																							defaultChecked={item.edit}
																						/>
																						<span className="checkmark"></span>
																					</label>
																				</li>
																			:
																				null
																			}
																			{
																			item.remove !== undefined ?
																				<li>
																					<label className="div-checkbox fs-5 mb-3">
																						Remover
																						<input
																							name={item.id + '_remove'}
																							className="checkbox-form"
																							type="checkbox"
																							onChange={handleSingleCheck}
																							defaultChecked={item.remove}
																						/>
																						<span className="checkmark"></span>
																					</label>
																				</li>	
																			:
																				null
																			}
																			{
																			item.dash !== undefined ?
																				<li>
																					<label className="div-checkbox fs-5 mb-3">
																						Dashboard
																						<input
																							name={item.id + '_dash'}
																							className="checkbox-form"
																							type="checkbox"
																							onChange={handleSingleCheck}
																							defaultChecked={item.dash}
																						/>
																						<span className="checkmark"></span>
																					</label>
																				</li>	
																			:
																				null
																			}
																			{
																			item.admin !== undefined ?
																				<li>
																					<label className="div-checkbox fs-5 mb-3">
																						Admin
																						<input
																							name={item.id + '_admin'}
																							className="checkbox-form"
																							type="checkbox"
																							onChange={handleSingleCheck}
																							defaultChecked={item.admin}
																						/>
																						<span className="checkmark"></span>
																					</label>
																				</li>	
																			:
																				null
																			}																			
																		</ul>
																	:
																		null
																	}
																</span>
															</div>
															<div>
																{
																item.submenu.map((sub, key2) => {
																	//console.log('SUB', sub.title)
																	//console.log('SUB', sub.apreciation)
																	if (sub.title === '')
																		return <div key={key2}></div>
																	else
																		return (
																			<div key={key2} className="form-group mt-3">
																				<span className="flex-1">
																					<div className='d-flex'>
																						<i className={"bi bi-dash-lg fs-5 me-4 invisible"}></i>
																						<label key={sub.id} className="div-checkbox fs-5">
																							<i className={"bi bi-dash-lg fs-5 me-2"}></i> {sub.title}
																							<input
																								name={sub.id}
																								className="checkbox-form"
																								type="checkbox"
																								value={sub.title}
																								onChange={handleSingleCheck}
																								defaultChecked={sub.allow === true ? true : false}
																							/>
																							<span className="checkmark"></span>
																						</label>
																					</div>
																				</span>
																				{// sub.title.includes('Lista') ?
																					<span className="flex-2">
																						{/*{console.log('SUB1001', sub)}*/}
																						<ul className='list-unstyled'>
																							{
																							sub.create !== undefined ?
																								<li>
																									<label className="div-checkbox fs-5 mb-3">
																										Criar
																										<input
																											name={sub.id + '_create'}
																											className="checkbox-form"
																											type="checkbox"
																											onChange={handleSingleCheck}
																											defaultChecked={sub.create}
																										/>
																										<span className="checkmark"></span>
																									</label>
																								</li>
																							:
																								null
																							}
																							{
																							sub.edit !== undefined ?
																								<li>
																									<label className="div-checkbox fs-5 mb-3">
																										Editar
																										<input
																											name={sub.id + '_edit'}
																											className="checkbox-form"
																											type="checkbox"
																											onChange={handleSingleCheck}
																											defaultChecked={sub.edit}
																										/>
																										<span className="checkmark"></span>
																									</label>
																								</li>
																							:
																								null
																							}
																							{
																							sub.remove !== undefined ?
																								<li>
																									<label className="div-checkbox fs-5 mb-3">
																										Remover
																										<input
																											name={sub.id + '_remove'}
																											className="checkbox-form"
																											type="checkbox"
																											onChange={handleSingleCheck}
																											defaultChecked={sub.remove}
																										/>
																										<span className="checkmark"></span>
																									</label>
																								</li>	
																							:
																								null
																							}
																							{
																							sub.dash !== undefined ?
																								<li>
																									<label className="div-checkbox fs-5 mb-3">
																										Dashboard
																										<input
																											name={sub.id + '_dash'}
																											className="checkbox-form"
																											type="checkbox"
																											onChange={handleSingleCheck}
																											defaultChecked={sub.dash}
																										/>
																										<span className="checkmark"></span>
																									</label>
																								</li>	
																							:
																								null
																							}
																							{
																							sub.admin !== undefined ?
																								<li>
																									<label className="div-checkbox fs-5 mb-3">
																										Admin
																										<input
																											name={sub.id + '_admin'}
																											className="checkbox-form"
																											type="checkbox"
																											onChange={handleSingleCheck}
																											defaultChecked={sub.admin}
																										/>
																										<span className="checkmark"></span>
																									</label>
																								</li>	
																							:
																								null
																							}
																						</ul>
																					</span>
																				//:
																				//	null
																				}
																			</div>
																		)
																})
																}
															</div>
														</div>
													)
											}
											)
										:
											null
										}
									</span>
								:
									null
								}
							</div>
						</form>

					</div>
				</div>
			</div>

			<div className={'dash-cards-2 footer'}>
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							<li className="nav-item">
								<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
								</Link>
							</li>
							{/* <li className={"nav-item "}>
								<button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
									<i className="bi bi-trash3 me-2"></i>
									<span>Eliminar</span>
								</button>
							</li> */}
							<li className="nav-item">
								<button type="submit" form="form" className="nav-link">
									<i className="bi bi-floppy me-2"></i>
									<span>{language[lang].save}</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</main>
}
